import { InputContainer, Label, ActiveButton } from 'application/styled-components'

export const FilterButton = ({ children, click, width, height, marginLeft, style }) => {
    return(
        <InputContainer width={ width } marginLeft={marginLeft} height={ height }>
            <Label>&nbsp;</Label>
            <ActiveButton onClick={ click } padding="0px" style={style} >{ children }</ActiveButton>
        </InputContainer>
    )
}